export function findCatalogTypeByCode(code, catalog) {
    const horizontalSignType = catalog.find(item => item.code === code)

    if (horizontalSignType) {
        return horizontalSignType
    } else {
        for (let item of catalog) {
            const type = findCatalogTypeByCode(code, item.children)
            if (type) {
                return type
            }
        }

        return null
    }
}

export function getFinalCatalogTypes(catalog) {

    const getLeafTypes = (types) => {
        let leafTypes = []

        types.forEach(type => {
            if (!type.children?.length) {
                leafTypes.push(type)
            } else {
                leafTypes = leafTypes.concat(getLeafTypes(type.children))
            }
        })

        return leafTypes
    }

    return getLeafTypes(catalog)
}

export function sortCatalogChildTypes(parent) {
    parent.children.sort((a, b) => a.code.localeCompare(b.code))
    parent.children.forEach(child => sortCatalogChildTypes(child))
}

export function isElementaryType(typeCode, catalog) {
    if (!catalog || !typeCode) {
        return false
    }
    const finalTypes = getFinalCatalogTypes(catalog)
    const finalType = finalTypes.find(type => type.code === typeCode)

    return !!finalType
}